import Spaces from './spaces';
import Space from './space';

export default Spaces;
export { Space, Spaces };
export {
  createSpace,
  deleteSpace,
  getSpace,
  getSpaces,
  searchSpaceChunks,
  updateSpace,
} from './spaces';
